import React from "react";
import { Page } from "../../../components";
import { NavTabs } from "../../../components2/NavSections";
import { RegisterFC } from "./RegisterFC";
import { MenuManager } from "./MenuManager";

const items = [
  { name: "shopName", displayName: "가맹점명" },
  { name: "posName", displayName: "사용포스" },
  { name: "addr", displayName: "주소" },
  { name: "ownername", displayName: "가맹점주 이름" },
  { name: "shopType", displayName: "업종" },
  { name: "storeCode", displayName: "가맹점 코드" },
  { name: "tableCount", displayName: "테이블 수" },
  { name: "tel", displayName: "전화번호" },
  { name: "orderCount", displayName: "누적 주문" },
  { name: "shopId", displayName: "가맹점 아이디" },
  { name: "created", displayName: "등록일시" },
]

export default function IndexFC(props) {
  const title = "프랜차이즈 관리"

  return (
    <Page stretch title={title}>
      <NavTabs>
        <MenuManager name="가맹점 정보 복사" />
        <RegisterFC name="프랜차이즈 세팅" />
      </NavTabs>
    </Page>
  );
}
